<template>
  <svg class="customIcon" fill="#808080" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 3C7.58 3 4 4.79 4 7V17C4 19.21 7.59 21 12 21S20 19.21 20 17V7C20 4.79 16.42 3 12 3M18 17C18 17.5 15.87 18.5 12 18.5S6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16S16.39 15.55 18 14.77V17M18 12.5C18 13 15.87 14 12 14S6 13 6 12.5V10.27C7.61 11.05 9.72 11.5 12 11.5S16.39 11.05 18 10.27V12.5M12 9.5C8.13 9.5 6 8.5 6 8S8.13 6.5 12 6.5 18 7.5 18 8 15.87 9.5 12 9.5Z" />
  </svg>
</template>

<script>
export default { name: "DatabaseIcon" };
</script>
